// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-host-content{
  position: relative;
  width: 100%;
  height: 100%;
  background-color: white;

}
.content-hostManage{
  width: 100%;
  height: 100%;
  position: relative;
  display: block;
}
.menu-hostManage{
  position: relative;
  width: 100%;
  height: 10%;
}
.display-menu-hostManage{
  position: relative;
  width: 100%;
  height: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
  /* background-color: red; */
}
.cont-button-hostManage{
  position: relative;
  width: 100%;
  height: 10%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.compact-section-menu-hostManage{
  position: relative;
  display: flex;
  width: 90%;
  height: 98%;
}
/*********************************************** menu horizontal ***********************************************************/
.menu-hostManage-content{
  position: relative;
  display: flex;
  justify-content: left;
  align-items: center;
  width: 100%;
  height: 100%;
}
.compact-menu-list-hostManage{
  position: relative;
  display: flex;
  width: 60%;
  height: 100%;
  left: 5%;
  justify-content: center;
  align-items: center;
  justify-content: space-between; /* Distribuye el espacio entre los elementos */
list-style-type: none; /* Elimina los estilos de viñetas de la lista */
padding: 0; /* Elimina el relleno predeterminado de la lista */
margin: 0; 
}
.compact-menu-list-hostManage li {
  /* flex-grow: 1; Permite que los elementos ocupen el espacio disponible */
  width: 25%;
  height: 50%;
  background-color: transparent;
  border-right: 1px solid #a1a1a150;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: medium;
  cursor: pointer;
  /* color: rgba(195,195,195,1); */
  color: #003757;
}
.compact-menu-list-hostManage li:hover{
  background-color: rgba(130, 134, 138, 0.452);
}
.list-hostManage-selected{
  /* background-color: rgba(195,195,195,1) !important; */
  background-color: #003757 !important;
  /* color: rgb(1, 17, 31) !important; */
  color:aliceblue !important;
}
.head-line-hostManage{
  width: 90%;
  position: absolute;
  left: 5%;
  top:70%;
  /* color:rgba(195,195,195,1); */
  color: 003757;
  }
  /******************************************************************************************************/
`, "",{"version":3,"sources":["webpack://./src/components/hostManage-components/styles/ModalCreateHost.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,uBAAuB;;AAEzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,WAAW;AACb;AACA,4HAA4H;AAC5H;EACE,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,YAAY;EACZ,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B,EAAE,8CAA8C;AAChF,qBAAqB,EAAE,+CAA+C;AACtE,UAAU,EAAE,kDAAkD;AAC9D,SAAS;AACT;AACA;EACE,yEAAyE;EACzE,UAAU;EACV,WAAW;EACX,6BAA6B;EAC7B,iCAAiC;EACjC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,sDAAsD;EACtD,oCAAoC;EACpC,sCAAsC;EACtC,0BAA0B;AAC5B;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,+BAA+B;EAC/B,aAAa;EACb;EACA,uGAAuG","sourcesContent":[".modal-host-content{\r\n  position: relative;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: white;\r\n\r\n}\r\n.content-hostManage{\r\n  width: 100%;\r\n  height: 100%;\r\n  position: relative;\r\n  display: block;\r\n}\r\n.menu-hostManage{\r\n  position: relative;\r\n  width: 100%;\r\n  height: 10%;\r\n}\r\n.display-menu-hostManage{\r\n  position: relative;\r\n  width: 100%;\r\n  height: 80%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  /* background-color: red; */\r\n}\r\n.cont-button-hostManage{\r\n  position: relative;\r\n  width: 100%;\r\n  height: 10%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n.compact-section-menu-hostManage{\r\n  position: relative;\r\n  display: flex;\r\n  width: 90%;\r\n  height: 98%;\r\n}\r\n/*********************************************** menu horizontal ***********************************************************/\r\n.menu-hostManage-content{\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: left;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n.compact-menu-list-hostManage{\r\n  position: relative;\r\n  display: flex;\r\n  width: 60%;\r\n  height: 100%;\r\n  left: 5%;\r\n  justify-content: center;\r\n  align-items: center;\r\n  justify-content: space-between; /* Distribuye el espacio entre los elementos */\r\nlist-style-type: none; /* Elimina los estilos de viñetas de la lista */\r\npadding: 0; /* Elimina el relleno predeterminado de la lista */\r\nmargin: 0; \r\n}\r\n.compact-menu-list-hostManage li {\r\n  /* flex-grow: 1; Permite que los elementos ocupen el espacio disponible */\r\n  width: 25%;\r\n  height: 50%;\r\n  background-color: transparent;\r\n  border-right: 1px solid #a1a1a150;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-size: medium;\r\n  cursor: pointer;\r\n  /* color: rgba(195,195,195,1); */\r\n  color: #003757;\r\n}\r\n.compact-menu-list-hostManage li:hover{\r\n  background-color: rgba(130, 134, 138, 0.452);\r\n}\r\n.list-hostManage-selected{\r\n  /* background-color: rgba(195,195,195,1) !important; */\r\n  background-color: #003757 !important;\r\n  /* color: rgb(1, 17, 31) !important; */\r\n  color:aliceblue !important;\r\n}\r\n.head-line-hostManage{\r\n  width: 90%;\r\n  position: absolute;\r\n  left: 5%;\r\n  top:70%;\r\n  /* color:rgba(195,195,195,1); */\r\n  color: 003757;\r\n  }\r\n  /******************************************************************************************************/\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
